import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {RoleAccess} from 'projects/core/src/lib/login/data/role-access';
import {UserRole} from 'projects/core/src/lib/login/data/user-role';
import {LoginService} from 'projects/core/src/public-api';
import {forkJoin} from 'rxjs';
import {UsersService} from '../../../users/data/users.service';
import {AccessEditorDialogComponent} from './access-editor-dialog/access-editor-dialog.component';
import {AdminPanelService} from '../../data/admin-panel.service';

@Component({
  selector: 'app-access-editor',
  templateUrl: './access-editor.component.html',
  styleUrls: ['./access-editor.component.scss']
})
export class AccessEditorComponent implements OnInit {
  accessButtons: RoleAccess[];

  allRoles: UserRole[]

  loadingSpinner = true;

  constructor(
    private dialog: MatDialog,
    private loginService: LoginService,
    protected adminPanelService: AdminPanelService,
    private usersService: UsersService
  ) {
  }

  ngOnInit(): void {
    forkJoin([this.usersService.getRoles(), this.loginService.getRolesAccess()]).subscribe(data => {
      const allRoles = data[0]
      const access = data[1]

      this.allRoles = allRoles;

      this.accessButtons = access;
      this.accessButtons.shift();

      this.loadingSpinner = false;
    })
  }

  editAccess(roleAccess: RoleAccess, index: number) {
    const dialogRef = this.dialog.open(AccessEditorDialogComponent, {
      data: {
        roleAccess,
        allRoles: this.allRoles
      },
      panelClass: 'access-editor-dialog'
    });

    dialogRef.afterClosed().subscribe(newButt => {
      if (newButt && newButt instanceof RoleAccess) {
        this.accessButtons[index] = newButt
      }
    })

  }

  createAccess() {
    const dialogRef = this.dialog.open(AccessEditorDialogComponent, {
      data: {
        roleAccess: {
          title: '',
          path: '',
          roles: [],
          id: null
        },
        allRoles: this.allRoles
      },
      panelClass: 'access-editor-dialog'
    });

    dialogRef.afterClosed().subscribe(newButton => {
      if (newButton && newButton instanceof RoleAccess) {
        this.accessButtons.push(newButton)
      }
    })

  }

  createNewRole() {
    this.adminPanelService.createRoleAccess({
      title: 'Pricing',
      path: '/pricing',
      roles: [],
      id: null
    }).subscribe(newRole => {

    })
  }
}
